export default __webpack_public_path__ + "static/media/flag-fr.9bf2ac6b.svg";